var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.signUp($event)
        }
      }
    },
    [
      _c("div", { staticClass: "modal__head" }),
      _vm._v(" "),
      _c("div", { staticClass: "modal__body" }, [
        _c("img", {
          attrs: {
            src: require("@assets/imgs/sphir-colored-logo.svg"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "input__field" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email"
              }
            ],
            attrs: {
              id: "email",
              type: "email",
              name: "email",
              placeholder: " ",
              required: ""
            },
            domProps: { value: _vm.email },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.email = $event.target.value
                },
                _vm.validateEmail
              ],
              keyup: function($event) {
                return _vm.clearError("login")
              }
            }
          }),
          _vm._v(" "),
          _c("label", { staticClass: "label", attrs: { for: "email" } }, [
            _vm._v(_vm._s(_vm.$t("INPUT.EMAIL")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input__field" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password"
              }
            ],
            attrs: {
              id: "password",
              type: "password",
              name: "password",
              placeholder: " ",
              required: ""
            },
            domProps: { value: _vm.password },
            on: {
              keyup: function($event) {
                return _vm.clearError("login")
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.password = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("label", { staticClass: "label", attrs: { for: "password" } }, [
            _vm._v(_vm._s(_vm.$t("INPUT.PASS")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text__right" }, [
          _c(
            "a",
            {
              staticClass: "text__right color__main text__bold fs__12",
              on: {
                click: function($event) {
                  return _vm.showForm("forgot")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("LINK.FORGOT")))]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal__footer" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.localError || _vm.error("login"),
                expression: "localError || error('login')"
              }
            ],
            staticClass: "error-message",
            domProps: {
              innerHTML: _vm._s(_vm.error("login") || _vm.localError)
            }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.localError || _vm.error("login")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn full__width btn__round",
            attrs: { type: "submit", disabled: _vm.isBtnDisabled },
            on: { click: _vm.signUp }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.message || _vm.$t("BUTTON.LOGIN")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text__center color__secondary fs__11 margin-t__15" },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("SIGN_IN.AGREE")) +
                "\n            "
            ),
            _c(
              "router-link",
              {
                staticClass: "text__bold color__secondary",
                attrs: { to: { name: "terms-of-use" }, target: "_blank" }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("LINK.TERM-2")) +
                    "\n            "
                )
              ]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }